import React from 'react';

const RestToRight = () => <div style={{ flexGrow: 1 }} />;

export default RestToRight;
